<template>
    <quill-editor 
        class="note-pane-quill-instance"
        v-model="content"
        @input="$emit('input', content)"
        :options="quillConfiguration"
        :disabled="isBusy"
    ></quill-editor>
</template>

<style lang="scss">
    .note-pane-quill-instance {
        position: relative;
        
        .ql-container {
            font-size: 1rem;
        }
    }
</style>

<script>
    import { NoteResource  } from '../../classes/Api/Note'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    // import { quillEditor } from 'vue-quill-editor'
    import quillEditor from '../../../ts/Quill/Editor.vue'

    const quillConfiguration = {
        placeholder: "",
        modules: {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                ['clean']  
            ]
        }
    }

    export default {
        components: { quillEditor },
        props: {
            value: {
                type: String,
                default: ''
            },
            isBusy: {
                type: Boolean,
                default: false
            },
            owners: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                content: '',
                quillConfiguration
            }
        },
        created() {
            this.content = this.value
        },
        methods: {
            reset() {
                this.content = ''
            },
            save() {
                return new Promise((resolve, reject) => {
                    this.$emit('saving')

                    let owners = this.owners.map(item => {
                        return item.type + ':' + item.id
                    })

                    NoteResource.store({ content: this.content, owners }).then(response => {
                        this.$emit('saved', response.data)
                        this.reset()
                        resolve(response.data)
                    }).catch(e => {
                        handleApiError(e, reject)
                        this.$emit('error', e)
                    })
                })
            },
        },
        watch: {
            value(n, o) {
                if (n !== o) {
                    this.content = n
                }
            }
        }
    }
</script>